export default __webpack_public_path__ + "0e16b478f406225106b0436308aaed7e.png";